import { LogoContainer } from "./Logo.styles";

const Logo = () => {
    return <LogoContainer>
	<div class="content">
		<h2>MemeSnap</h2>
		<h2>MemeSnap</h2>
	</div>
</LogoContainer>
}

export default Logo;